import { useMemo, useEffect } from 'react';
import { ThemeProvider as MuiThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { useThemeStore } from '@shared/hooks/useThemeStore';
import { buildTheme, type BrandingThemeTokens } from './theme/buildTheme';
import { syncCssVariables } from './theme/syncCssVariables';

interface Props {
  brandingTokens?: BrandingThemeTokens;
  children: React.ReactNode;
}

export function ThemeProvider({ brandingTokens, children }: Props) {
  const mode = useThemeStore((s) => s.mode);

  const theme = useMemo(() => buildTheme(mode, brandingTokens), [mode, brandingTokens]);

  // Toggle dark class on <html> for Tailwind
  useEffect(() => {
    const root = document.documentElement;
    if (mode === 'dark') {
      root.classList.add('dark');
    } else {
      root.classList.remove('dark');
    }
  }, [mode]);

  // Sync CSS variables whenever theme changes
  useEffect(() => {
    syncCssVariables(theme);
  }, [theme]);

  return (
    <MuiThemeProvider theme={theme}>
      <CssBaseline />
      {children}
    </MuiThemeProvider>
  );
}
